import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Refund & Cancellation Policy - asdflo</title>
        <meta name="description" content="Review our refund and cancellation policy for asdflo services." />
      </Helmet>
      
      <Header />
      
      <main className="flex-grow bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white shadow overflow-hidden sm:rounded-lg">
            <div className="px-4 py-5 sm:px-6">
              <h1 className="text-3xl font-bold text-gray-900">Refund & Cancellation Policy</h1>
              <p className="mt-1 max-w-2xl text-sm text-gray-500">Last updated: July 28, 2024</p>
            </div>
            <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
              <div className="prose max-w-none px-6 py-4 sm:px-6">
                <ul className="list-disc pl-6 space-y-4 text-gray-700">
                  <li>Sessions cancelled 24 hours in advance are eligible for a 100% refund.</li>
                  <li>No refund for same-day cancellations or missed appointments.</li>
                  <li>Technical issues or therapist no-shows will be fully refunded or rescheduled.</li>
                  <li>Refunds will be processed within 5–7 working days.</li>
                </ul>
                <p className="mt-6 text-gray-700">
                  For any questions about our refund policy, please contact us at: <a href="mailto:info@asdflo.com" className="text-blue-600 hover:underline">info@asdflo.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default RefundPolicy;
